<template>
  <f7-card>
    <f7-card-header>
      <span style="font-size: 16px; height: 24px; line-height: 24px;">
        <img
          v-if="item.coverImgUrl"
          :src="ImageUrlBuilder.url64(item.coverImgUrl, storeId)"
          :srcset="`${ImageUrlBuilder.url128(item.coverImgUrl, storeId)} 2x, ${ImageUrlBuilder.url192(item.coverImgUrl, storeId)} 3x`"
          style="width: 24px;  float: left;"
          slot="media"
          alt="餐點圖片">
        <img v-else slot="media" src="@/assets/itemDefault.jpg" style="width: 24px;" alt="餐點圖片" />
        <span style="position: absolute; margin-left: 12px; top: 4px;">
          <div style="">{{ item.title }}</div>
          <div style="font-size: 12px; line-height: 16px; color: #AAAAAA; margin-left: 2px;">${{ item.price }}</div>
        </span>
      </span>
      <f7-button
        style="min-width: 36px; border-radius: 5px; padding: 0px; margin-right: -10px;"
        :style="{ color: favoriteExist ? '#FF6666' : '#AAAAAA'}"
        @click="toggleItemInFavorites(itemObj)">
        <div style="margin-top: -8px;">
          <font-awesome-icon icon="heart" />
        </div>
        <div v-if="favoriteExist" style="margin-top: -20px; font-size: 12px;">{{ $t(`contentAdjustment.addedToFavorites`) }}</div>
        <div v-else style="margin-top: -20px; font-size: 12px;">{{ $t(`contentAdjustment.addToFavorites`) }}</div>
      </f7-button>
    </f7-card-header>
    <f7-card-content v-if="questions.length !== 0">
      <div @click="modifyOnClick">
        <template v-for="(question, index) in questions" v-if="shouldDisplayQuestion(question)">
          <cart-card-content :key="`item-card-questions-${index}`" :itemObj="itemObj" :questionId="question.id" />
        </template>
        <div v-if="itemObj.specialRequests" style="color: #888888; width: 100%; display: inline-block;">
          {{ $t(`contentAdjustment.specialRequests`) }}: {{ itemObj.specialRequests }}
        </div>
      </div>
    </f7-card-content>
    <f7-card-footer style="padding-left: 5px;">
      <f7-button v-if="questions.length !== 0 || item.allowSpecialRequests" @click="modifyOnClick" color="gray" style="padding: 0px; min-width: 64px;">
        <font-awesome-icon icon="edit" />
        <span style="">{{ $t(`contentAdjustment.edit`) }}</span>
      </f7-button>
      <span
        v-if="questions.length !== 0"
        style="position: relative; top: 1px; border: solid 2px #d5d5d5; border-width: 0px 1px 0px 0px; width: 1px; height: 20px; margin: 0px 6px 0px 5px;">
      </span>
      <f7-button color="gray" style="margin-left: 10px; padding: 0px; min-width: 64px; width: 128px; text-align: left;" @click="REMOVE_ITEM({ id: item.id, instanceId: item.stateObj.instanceId })">
        <font-awesome-icon icon="trash" />
        {{ $t(`contentAdjustment.remove`) }}
      </f7-button>
      <span style="width: 100%; text-align: right;">{{ $t(`contentAdjustment.price`) }} {{ item.totalPrice }}</span>
    </f7-card-footer>
  </f7-card>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { REMOVE_ITEM } from '../store/itemModule/mutation-types'
import CartCardContent from './CartCardContent'
import * as R from 'ramda'

export default {
  name: 'ItemCard',
  dependencies: [
    'ImageUrlBuilder',
    'CartElementBuilder'
  ],
  props: {
    itemObj: Object,
    itemIndex: Number,
    itemBucket: String
  },
  computed: {
    ...mapGetters([
      'currentMenu',
      'storeId'
    ]),
    ...mapGetters('itemModule', [
      'getItemPrice',
      'allFavoriteItems'
    ]),
    item () {
      return this.CartElementBuilder.buildItem(this.itemObj, this.currentMenu)
    },
    questions () {
      return this.item.questions
        ? this.item.allLevelQuestions.map(q => this.CartElementBuilder.buildQuestion(q.id, this.itemObj, this.currentMenu))
        : []
    },
    favoriteExist () {
      if (this.allFavoriteItems.some(item =>
        item.id === this.itemObj.id &&
          R.equals(item.values, this.itemObj.values) &&
          item.specialRequests === this.itemObj.specialRequests)
      ) {
        return true
      }
      return false
    }
  },
  methods: {
    ...mapMutations('itemModule', [REMOVE_ITEM]),
    ...mapActions('itemModule', [
      'removeItem',
      'addItemToFavorites'
    ]),
    modifyOnClick () {
      this.$f7.views.main.router.navigate(`/stores/${this.storeId}/items/cart/${this.item.id}.${this.item.stateObj.instanceId}/questions`, {
        props: {
          edit: true
        }
      })
    },
    shouldDisplayQuestion: question =>
      question.alwaysDisplay ||
      !question.isValid ||
      !question.isValueDefault ||
      question.totalPrice !== 0,
    toggleItemInFavorites (itemObj) {
      if (this.favoriteExist) {
        const favoriteItem = this.allFavoriteItems.find(item =>
          item.id === this.itemObj.id &&
            R.equals(item.values, this.itemObj.values))
        this.removeItem({ id: favoriteItem.id, instanceId: favoriteItem.instanceId, itemBucket: favoriteItem.itemBucket })
      } else {
        if (this.item.isValid) {
          this.addItemToFavorites(itemObj)
        } else {
          this.$f7.dialog.alert('請先點選「修改」並完成餐點所有選項', '表單未完成')
        }
      }
    }
  },
  components: {
    CartCardContent
  }
}
</script>
